//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Input from 'ui-kit/src/components/form/Input';

export default {
    extends: Input,

    constants: {
        maxFileSize: appConfig.upload.maxFileSize,
    },

    props: {
        value: Array,
        accept: {
            type: String,
            default: '.jpg,.jpeg,.pdf,.doc,.docx,.odt',
        },
        single: Boolean,
        noDrag: Boolean,
        noTempList: Boolean,
        safeRemoveFn: Function,
    },

    data() {
        return {
            queuedFiles: [],
        };
    },

    computed: {
        url() {
            return `${appConfig.app.baseApiUrl}/upload`;
        },
        headers() {
            return [
                {
                    name: 'Authorization',
                    value: `Bearer ${localStorage.getItem('authToken')}`,
                },
            ];
        },
        allFiles() {
            return [
                ...this.queuedFiles,
                ...this.model.filter(f => !f.removed),
            ];
        },
    },

    methods: {
        nameFn(file) {
            return file.originalName ?? $.getOriginalFilename(file.name);
        },
        progressFn(file) {
            return file.progress;
        },
        hasErrorFn(file) {
            return file.error;
        },
        canDownloadFn(file) {
            return !file.temp;
        },
        downloadFn(file) {
            $.downloadFile(file);
        },
        removeFn(file) {
            if (file.progress != null) {
                file.canceler?.cancel();

                $.removeOne(this.queuedFiles, file);
            } else if (file.temp) {
                $.removeOne(this.model, file);
            } else if (this.safeRemoveFn) {
                this.safeRemoveFn(file);
            } else {
                $.set(file, 'removed', true);
            }
        },
        addFiles(files) {
            if (this.single) {
                files = [files[0]];
            }

            for (const file of files) {
                this.addFile(file);
            }
        },
        async addFile(browserFile) {
            if (this.single && this.allFiles.length) {
                this.removeFn(this.allFiles[0]);
            }

            const queuedFile = {
                originalName: browserFile.name,
                progress: 0,
                error: false,
            };

            this.queuedFiles.push(queuedFile);

            const formData = new FormData();

            formData.append('files', browserFile);

            let fileName;

            try {
                queuedFile.canceler = axios.getCanceler();

                const response = await axios.post(this.url, formData, {
                    headers: this.headers,
                    maxBodyLength: this.maxFileSize,
                    cancelToken: queuedFile.canceler.token,
                    onUploadProgress(ev) {
                        queuedFile.progress = ev.loaded / ev.total;
                    },
                });

                fileName = response.data[0];
            } catch (err) {
                queuedFile.error = true;

                return;
            }

            debug.info("Uploaded file:", fileName);

            $.removeOne(this.queuedFiles, queuedFile);

            this.model.push({
                name: fileName,
                temp: true,
            });
        },
        onDrop(data) {
            if (data.files.length) {
                this.addFiles(data.files);
            }
        },
    },
};
